
// import { fadeBanner, unfadeBanner } from './components.hero-banner';
import { getElements, getClasses } from './components.site-navigation';
import detectTouchscreen from '../utils/utils.detect-touchscreen';

const $ = jQuery;

var initialised = false,
	elements,
	classes;

const 	settings = {
			hoverDebounceTiming: 222
		};

export function navIsInitialised() {
	return initialised;
}

export function reset() {

	if ( navIsInitialised() ) {

		initialised = false;

		elements.$siteNavItemWithChildren.off('mouseenter.menufade');
		elements.$siteNavItemWithChildren.off('mouseenter.subnav');
		elements.$siteNavSubItemWithChildren.off('mouseenter.subsubnav');

		elements.$subNav.attr('style', '');
		elements.$subSubNav.attr('style', '');
	}
}

function showSubNav($subNavToShow) {
	// $.Velocity.animate($subNavToShow, { opacity: 1 }, { duration: 333 });
	$subNavToShow.css({
		opacity: 1
	});
}

function hideSubNav($subNavToHide) {
	// $.Velocity.animate($subNavToHide, { opacity: 0 }, { duration: 333 });
	$subNavToHide.css({
		opacity: 0
	});
}

function addSubNavHover($itemWithChildren, eventNamespace, subNavClass) {

	$itemWithChildren.each( (i, elem) => {

		var hoverOuttimer,
			hoverInTimer;

		$(elem).on('mouseenter.' + eventNamespace, e => {

			const 	$hoveredItem = $(e.currentTarget),
					$subNav = $hoveredItem.find(subNavClass);
			
			hoverInTimer = window.setTimeout( () => {
				$hoveredItem.addClass(classes.isHovered);
				showSubNav($subNav);
			}, 333);
			
			clearTimeout(hoverOuttimer);

			$hoveredItem.on('mouseleave.' + eventNamespace, function mouseLeave() {

				clearTimeout(hoverInTimer);

				$hoveredItem.off('mouseleave.' + eventNamespace, mouseLeave);
				hoverOuttimer = window.setTimeout(() => {
					hideSubNav($subNav);
					$hoveredItem.removeClass(classes.isHovered);
				}, settings.hoverDebounceTiming);

			});
		});
	});
}

function setAnywhereClickToCloseItems($firstLevelLabels, $firstLevelCheckboxes, $secondLevelLabels, $secondLevelCheckboxes) {
	$('body').on('click.anywhere', e => {

		console.log('yeah');

		if ( ! $(e.target).parents().hasClass('js-site-nav-item') ) {

			$firstLevelLabels.removeClass(classes.isActive);
			$firstLevelCheckboxes.each(function() {
				$(this).get(0).checked = false;
			});
			
			$secondLevelLabels.removeClass(classes.isActive);
			$secondLevelCheckboxes.each(function() {
				$(this).get(0).checked = false;
			});

			removeAnywhereClickToCloseItems();
		}
	});
}

function removeAnywhereClickToCloseItems() {
	$('body').off('click.anywhere');
}

function addTouchEventListeners() {
	
	const 	$firstLevelLabels = elements.$subNavLabels.filter('[data-depth="1"]'),
			$firstLevelCheckboxes = elements.$navSubNavCheckboxes.filter('[data-depth="1"]'),
			$secondLevelLabels = elements.$subNavLabels.filter('[data-depth="2"]'),
			$secondLevelCheckboxes = elements.$navSubNavCheckboxes.filter('[data-depth="2"]');

	$firstLevelLabels.on('click', e => {
		
		const 	$clickedElem = $(e.currentTarget),
				$clickedElemLinkHref = $clickedElem.siblings('a').attr('href'),
				id = $clickedElem.attr('for'),
				$checkboxToCheck = $firstLevelCheckboxes.filter('[id="' + id + '"]');

		e.stopPropagation();
		
		removeAnywhereClickToCloseItems();
		setAnywhereClickToCloseItems($firstLevelLabels, $firstLevelCheckboxes, $secondLevelLabels, $secondLevelCheckboxes);

		// if activated, go to link
		if ( $clickedElem.hasClass(classes.isActive) && $clickedElemLinkHref !== '#' ) {
			window.location = $clickedElemLinkHref;
		}

		$firstLevelLabels.not($clickedElem).removeClass(classes.isActive);
		$clickedElem.toggleClass(classes.isActive);
		$firstLevelCheckboxes.not($checkboxToCheck).each(function() {
			$(this).get(0).checked = false;
		});

		$secondLevelLabels.removeClass(classes.isActive);
		$secondLevelCheckboxes.each(function() {
			$(this).get(0).checked = false;
		});

		if ( $clickedElem.hasClass(classes.isActive) ) {
			// fadeBanner();
		} else {
			// unfadeBanner();
		}
	});

	$secondLevelLabels.on('click', e => {
		const 	$clickedElem = $(e.currentTarget),
				$clickedElemLinkHref = $clickedElem.siblings('a').attr('href'),
				id = $clickedElem.attr('for'),
				$checkboxToCheck = $secondLevelCheckboxes.filter('[id="' + id + '"]');

		e.stopPropagation();

		// if activated, go to link
		if ( $clickedElem.hasClass(classes.isActive) && $clickedElemLinkHref !== '#' ) {
			window.location = $clickedElemLinkHref;
		}
		
		$secondLevelLabels.not($clickedElem).removeClass(classes.isActive);
		$clickedElem.toggleClass(classes.isActive);
		$secondLevelCheckboxes.not($checkboxToCheck).each(function() {
			$(this).get(0).checked = false;
		});
	});

	// TODO: clicking off the nav anywhere will close all navs
}

function addHoverEventListeners() {

	(function mouseenterAndMouseleaveMenu() {
		
		var hoverOuttimer,
			hoverInTimer;

		elements.$siteNavItemWithChildren.on('mouseenter.menufade', e => {

			const 	$hoveredItem = $(e.currentTarget),
					$subNavToShow = $hoveredItem.find('.js-sub-nav');
			
			hoverInTimer = window.setTimeout( () => {
				// fadeBanner();
			}, 333);

			clearTimeout(hoverOuttimer);

			elements.$siteNavItemWithChildren.on('mouseleave.menufade', function mouseLeave() {

				clearTimeout(hoverInTimer);

				elements.$siteNavItemWithChildren.off('mouseleave.menufade', mouseLeave);
				hoverOuttimer = window.setTimeout(() => {
					// unfadeBanner();
				}, settings.hoverDebounceTiming);

			});
		});

	})();

	addSubNavHover(elements.$siteNavItemWithChildren, 'subnav', '.js-sub-nav');
	addSubNavHover(elements.$siteNavSubItemWithChildren, 'subsubnav', '.js-sub-sub-nav');
}

export function init() {
	
	elements = getElements();
	classes = getClasses();

	if ( ! navIsInitialised() ) {

		if ( detectTouchscreen() ) {
			elements.$siteNav.addClass('is-touch');
			addTouchEventListeners();
		} else {
			elements.$subNav.css('opacity', 0);
			elements.$subSubNav.css('opacity', 0);
			addHoverEventListeners();
		}

		initialised = true;
	}
}